import { apiRequest } from '../../../shared/services/apiClient';

export const AI_TRANSFER_SECTIONS = [
  'apiToolConnections',
  'apiTools',
  'mcpServers',
  'mcpTools',
  'knowledgeDataCategories',
  'knowledgeDynamicTools',
  'aiToolOrchestrators',
  'useCasePolicies',
  'promptTemplates',
  'aiProviders',
] as const;

export type AiTransferSection = typeof AI_TRANSFER_SECTIONS[number];

export type AiConfigurationBundle = {
  schemaVersion: string;
  exportedAt: string;
  sourceTenantId?: string;
  includedSections: string[];
  redactedFields: string[];
  warnings: string[];
  payload: Record<string, unknown>;
};

export type AiConfigurationImportSectionPreview = {
  section: string;
  incomingCount: number;
  existingCount: number;
  conflictCount: number;
  sampleConflicts: string[];
};

export type AiConfigurationImportPreview = {
  schemaVersion: string;
  exportedAt?: string;
  sections: AiConfigurationImportSectionPreview[];
  warnings: string[];
  errors: string[];
};

export type AiConfigurationImportSectionResult = {
  section: string;
  created: number;
  updated: number;
  skipped: number;
  failed: number;
};

export type AiConfigurationImportResult = {
  sections: AiConfigurationImportSectionResult[];
  warnings: string[];
  errors: string[];
};

export const exportAiConfiguration = async (
  sections: AiTransferSection[],
): Promise<AiConfigurationBundle> => {
  return apiRequest<AiConfigurationBundle>('/api/v1/ai/transfer/export', {
    method: 'POST',
    body: JSON.stringify({ sections }),
  });
};

export const previewAiConfigurationImport = async (
  bundle: unknown,
  sections?: AiTransferSection[],
): Promise<AiConfigurationImportPreview> => {
  return apiRequest<AiConfigurationImportPreview>('/api/v1/ai/transfer/import/preview', {
    method: 'POST',
    body: JSON.stringify({ bundle, sections }),
  });
};

export const importAiConfiguration = async (
  bundle: unknown,
  importMode: 'skipExisting' | 'replaceExisting',
  sections?: AiTransferSection[],
): Promise<AiConfigurationImportResult> => {
  return apiRequest<AiConfigurationImportResult>('/api/v1/ai/transfer/import', {
    method: 'POST',
    body: JSON.stringify({ bundle, importMode, sections }),
  });
};
